import { createContext, useContext } from "react";
import { useImmerReducer } from "use-immer";

const accountSettingsInit = {
  accountSettings: {},
  isLoadingAccountSettings: false,
};

function accountSettingsReducer(draft, { type, payload }) {
  switch (type) {
    case "setAccountSettings": {
      let newState={}
      payload.AccountSettings.forEach(setting => newState[[setting.id]] = setting)
      draft.accountSettings = newState
      break;
    }
    case "setIsLoadingAccountSettings": {
      draft.isLoadingAccountSettings = payload;
      break;
    }
    default: {
      return null;
    }
  }
}

const [AccountSettingContext, AccountSettingDispatchContext] = [
  createContext(null),
  createContext(null),
];

export default function AccountSettingProvider({ children }) {
  const [accountSettingStore, dispatch] = useImmerReducer(accountSettingsReducer, accountSettingsInit);

  return (
    <AccountSettingContext.Provider value={accountSettingStore}>
      <AccountSettingDispatchContext.Provider value={dispatch}>
        {children}
      </AccountSettingDispatchContext.Provider>
    </AccountSettingContext.Provider>
  );
}

export function useAccountSettingStore() {
  return useContext(AccountSettingContext);
}

export function useAccountSettingDispatch() {
  return useContext(AccountSettingDispatchContext);
}